import type { ExpenseCategory, TaxEstimate } from '@eriko/shared-types';
import { CategoryBreakdown, CategoryBreakdownSkeleton } from './CategoryBreakdown';
import { TaxEstimateCard, TaxEstimateSkeleton } from './TaxEstimate';

const TARGET_CATEGORY_COUNT = 12;

interface ReportsCategorySectionProps {
  categories: ExpenseCategory[];
  taxEstimate: TaxEstimate;
  loading: boolean;
}

export function ReportsCategorySection({
  categories,
  taxEstimate,
  loading,
}: ReportsCategorySectionProps) {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-[1.35fr_1fr] gap-6 mb-12">
      <div className="bg-surface-0/60 border border-surface-300/70 rounded-[6px] px-8 py-7">
        <div className="flex items-center justify-between mb-6">
          <span className="font-mono text-[10px] uppercase tracking-[2px] text-surface-600">
            Where the money went
          </span>
          {loading ? (
            <span
              aria-hidden
              className="h-3 w-16 bg-surface-200/80 rounded-sm animate-pulse"
            />
          ) : (
            <span className="font-mono text-[11px] text-surface-600">
              {categories.length} / {Math.max(categories.length, TARGET_CATEGORY_COUNT)} cat.
            </span>
          )}
        </div>
        {loading ? (
          <CategoryBreakdownSkeleton />
        ) : (
          <CategoryBreakdown categories={categories} />
        )}
      </div>

      {loading ? <TaxEstimateSkeleton /> : <TaxEstimateCard data={taxEstimate} />}
    </section>
  );
}
